import { type FC } from 'react'

import { ContactPageCtaListGuest } from './ContactPageCtaListGuest'
import { ContactPageCtaListLoggedIn } from './ContactPageCtaListLoggedIn'
import { ContactPageLastOrderProvider } from './ContactPageLastOrderContext'

export const ContactPageOrdersSectionContent: FC<{
  handleLoginModalOpen: () => void
  isUserLoggedIn: boolean
}> = ({ handleLoginModalOpen, isUserLoggedIn }) => {
  return (
    <div className="w-full">
      {isUserLoggedIn ? (
        <ContactPageLastOrderProvider>
          <ContactPageCtaListLoggedIn />
        </ContactPageLastOrderProvider>
      ) : (
        <ContactPageCtaListGuest handleLoginModalOpen={handleLoginModalOpen} />
      )}
    </div>
  )
}
